// Global pull-to-refresh registry. Pages register an async handler; when the
// user pulls down, all handlers run. With no handler we hard-reload the page.
const handlers = new Set();

export function registerPullRefresh(fn) {
  handlers.add(fn);
  return () => handlers.delete(fn);
}

export async function runPullRefresh() {
  if (handlers.size === 0) {
    window.location.reload();
    return new Promise(() => {}); // keep spinner until reload
  }
  await Promise.allSettled([...handlers].map((f) => {
    try { return Promise.resolve(f()); } catch { return Promise.resolve(); }
  }));
}
